import { Category } from './insurance.model';
import { Attachment } from './attachment.model';
import { ITodo } from './todo.interface';
import { InsuranceGroup, InsuranceProvider } from './insurance.model';
import { ClientDetailsModel } from './client/client.model';
import { PeriodOfNoticeEnum } from '../enum';

export class ShortClientInfoModel {
  id: string;
  insuranceProviderName: string;
  poolProviderName?: string;
  insuranceGroupName: string;
  contractGroupName: string;
  spriteCoordinate: string;
  uid: string;
  poolIdentifier: string;
  interval: string;
  price: number;
  title: string;
  type: string;
  contractNumber: string;
  sharable: boolean;
  icon: string;
  contractGroupIcon: string;
  attachmentCount: number;
  policyTransferState: PolicyTransferState = new PolicyTransferState();
}

export class Contract {
  id: number;
  uid: string;
  uuid: string;
  title: string;
  created: Date;
  contractStartDate: Date | string;
  contractEndDate: Date | string;
  owner: ClientDetailsModel;
  contractType: string;
  insuranceGroup: InsuranceGroup = null;
  insuranceProvider: InsuranceProvider = null;
  poolProviderName?: string;
  insuranceGroupName?: string;
  spriteCoordinate: string;
  insuranceProviderName?: string;
  contractNumber: string;
  clientNumber: string;
  paymentIntervalType: string;
  contractGroup: ContractGroup = null;
  keycloakClientId: string;
  amount: number;
  netAmount: number;
  note: string;
  sharable: boolean;
  clientKeycloakId: string;
  category: Category;
  terminationDetails: TerminationDetails = new TerminationDetails();
  attachments: Array<Attachment> = new Array<Attachment>();
  unreadMessages: number;
  totalMessages: number;
  closedTodos: Array<ITodo> = new Array<ITodo>();
  openTodos: Array<ITodo> = new Array<ITodo>();
  rating: number;
  advice: string;
  lastUpdate: Date;
  contractAdvice: ContractAdvice;
  icon: string;
  isPoolContract: boolean;
  poolStatus: Map<string, string>;
  processStatus: string;
  contractPoolTransferState: string;
  poolContractLink: string;
  poolIdentification: string;
  editMode: boolean = true;
  advisorCanEdit: boolean = true;
  finoContractId: string;
  archived: boolean;
  policyTransferState: PolicyTransferState = new PolicyTransferState();
  activeConversation?: boolean;
}

export class OwnerModel {
  keycloakId: string;
  id: number;
  email: string;
  firstname: string;
  lastname: string;
  profilePictureUrl: string;
  street: string;
  houseNumber: string;
  zip: string;
  city: string;
  mobile: string;
  advisor: null;
  isNewCustomer: boolean;
  created: Date;
  isEnabled: boolean;
  isPoolClient: boolean;
  birthday: string;
  hasPoolMandate: boolean;
  poolIdentification: string;
  mandateApprovalStatus: null;
  taxId: null;
  leadCustomer: boolean;
}

export interface IPill {
  title: string;
  active: boolean;
  uploadParam: string;
}

export class ContractOverviewRequest {
  criteria: ContractOverviewCriteria[] = [];
  sort: string[] = [];
  perPage: number = 25;
  pageNr: number = 0;
  advisorId: string = null;
}

export class ContractOverviewResponse {
  totalPages: number;
  totalNrOfItems: number;
  pageNr: number;
  data: ContractShortModel[];
}

export class ContractOverviewCriteria {
  field: string;
  value: number | boolean | string;
}

export class ContractShortModel {
  uuid: string;
  clientFirstName: string;
  clientLastName: string;
  clientKeycloakId: number;
  advisorFirstName: string;
  advisorLastName: string;
  insuranceGroupName: string;
  insuranceProviderName: string;
  amount: number;
  intervalType: string;
  contractNumber: string;
  poolIdentification: null;
  contractPoolTransferState: string;
  spriteCoordinate: string;
  policyTransferState: PolicyTransferState = new PolicyTransferState();
  attachmentCount: number;
}

export class DetectedContractsResponseModel {
  insurance: Contract[];
  other: Contract[];
}

export class ContractAdvice {
  id: number;
  uid: string;
  ratingType: string;
  advice: string = '';
  attachments: Array<Attachment> = new Array<Attachment>();
}

export class ChatMessage {
  id: string;
  contractUid: string;
  message: string;
  client: ShortClientInfoModel;
  advisor: ShortClientInfoModel;
  userType: string;
  created: Date;
  dateLabel: string;
  readAt: Date;
  attachments: Array<Attachment>;
}

export class ClientChat {
  totalMessages: number;
  unreadMessages: number;
  clientUid: string;
  uid?: string;
  contractType?: string;
  lastMessage?: string;
}

export interface ClientContracts {
  insuranceContracts?: ShortClientInfoModel[];
  otherContracts?: ShortClientInfoModel[];
}

export class ContractGroup {
  id: number;
  name: string;
  icon: string;
  color: string;
  contractGroupType: string;
}

export class ContractUnread {
  contractId: number;
  unreadMessages: number;
}

export class ContractsRequest {
  clientId: string;
  contractGroup: ContractGroup = null;
  sortContractType: any = null;
}

export class TerminationDetails {
  id: string;
  created: Date;
  note: string;
  active: boolean = false;
  reminderDate: Date;
  periodOfNotice: PeriodOfNoticeEnum;
}

export class PolicyTransferState {
  typ: string;
  status: string;
}

export class BatchContractTransferResultModel {
  contractUid: string;
  success: boolean;
  error: string | null;
}

export class BatchContractTransferResponseModel {
  totalCount: number;
  successCount: number;
  failureCount: number;
  results: BatchContractTransferResultModel[];
}
